import React, { createContext, useContext, useMemo, useState } from "react";
import { translations } from "./i18n";

const LangContext = createContext({ lang: "fr", setLang: () => {}, t: translations.fr });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
